import React, { useState } from "react";

import { trackAmplitudeEvent } from "../../amplitude";
import StorySheet from "./StorySheet";
import { CLOZE_MODE, STORIES_EVENTS } from "./storiesEvents";
import { requestJson } from "./storiesHelpers";

export default function StoryFeedbackSheet({ featureFeedbackUrl, mode, story, storyFeedbackUrl, targetLanguageName, onClose }) {
  const [votes, setVotes] = useState({});
  const [hasError, setHasError] = useState(false);

  const sendVote = (feedbackType, isUpVote) => {
    if (feedbackType === "story") {
      return requestJson({ data: { up_vote: isUpVote }, method: "post", url: storyFeedbackUrl });
    }
    return requestJson({
      data: {
        feature_name: feedbackType,
        include_account_details: true,
        language_studied: targetLanguageName,
        message: `${isUpVote ? "Thumbs up" : "Thumbs down"}\n\n---\nStory: ${story.title}, Level: ${story.cefrLevel}, Mode: ${mode}`,
        platform: "web"
      },
      method: "post",
      url: featureFeedbackUrl
    });
  };

  const vote = async (feedbackType, isUpVote) => {
    setHasError(false);
    setVotes((previous) => ({ ...previous, [feedbackType]: isUpVote }));
    trackAmplitudeEvent(STORIES_EVENTS.STORY_FEEDBACK_SUBMITTED, {
      feedback_type: feedbackType,
      mode,
      sentiment: isUpVote ? "positive" : "negative",
      story_id: story.id
    });
    try {
      await sendVote(feedbackType, isUpVote);
    } catch {
      setVotes((previous) => ({ ...previous, [feedbackType]: undefined }));
      setHasError(true);
    }
  };

  const questions = [
    { feedbackType: "story", prompt: "Did you enjoy this story?" },
    ...(mode === CLOZE_MODE ? [{ feedbackType: "cloze_stories", prompt: "How do you like Cloze Stories?" }] : [])
  ];

  return (
    <StorySheet
      footer={<button className="btn btn-success btn-lg story-sheet-primary" data-testid="story-feedback-done" type="button" onClick={onClose}>Done</button>}
      testId="story-feedback-sheet"
      title="Feedback"
      onClose={onClose}
    >
      {questions.map(({ feedbackType, prompt }) => (
        <section className="story-sheet-section" key={feedbackType}>
          <p className="story-feedback-prompt">{prompt}</p>
          <div className="story-sheet-buttons">
            {[false, true].map((isUpVote) => (
              <button
                aria-label={isUpVote ? "Thumbs up" : "Thumbs down"}
                className={`story-feedback-vote${votes[feedbackType] === isUpVote ? " selected" : ""}`}
                data-testid={`story-feedback-${feedbackType}-${isUpVote ? "up" : "down"}`}
                key={String(isUpVote)}
                type="button"
                onClick={() => vote(feedbackType, isUpVote)}
              >
                {isUpVote ? "👍" : "👎"}
              </button>
            ))}
          </div>
        </section>
      ))}
      {hasError && <p className="text-danger">Something went wrong. Please try again.</p>}
    </StorySheet>
  );
}
